var initBurningCake = function initBurningCake() {
  handleBurningOption();
  handleRevealedOption();
};
var handleBurningOption = function handleBurningOption() {
  var burningOptions = document.querySelectorAll('input[name="burnt-type"]');
  var burningTextInput = document.querySelector('.inputs-for-burnt .text-form');
  var burningImageInput = document.querySelector('.inputs-for-burnt .image-upload-container');
  burningOptions.forEach(function (option) {
    option.addEventListener('change', function (event) {
      var selectedOption = event.target.value;
      console.log("awlwcfe", selectedOption);
      if (selectedOption === 'text') {
        burningTextInput.classList.remove('hidden');
        burningTextInput.querySelector('input').setAttribute('required', 'required');
        burningImageInput.classList.add('hidden');
        burningImageInput.querySelector('input').value = '';
        burningImageInput.querySelector('input').removeAttribute('required');
      } else {
        burningTextInput.classList.add('hidden');
        burningTextInput.querySelector('input').removeAttribute('required');
        burningTextInput.querySelector('input').value = '';
        burningImageInput.classList.remove('hidden');
        burningImageInput.querySelector('input').setAttribute('required', 'required');
      }
    });
  });
};
var handleRevealedOption = function handleRevealedOption() {
  var revealedOptions = document.querySelectorAll('input[name="revealed-type"]');
  var revealedTextInput = document.querySelector('.inputs-for-revealed .text-form');
  var revealedImageInput = document.querySelector('.inputs-for-revealed .image-upload-container');
  revealedOptions.forEach(function (option) {
    option.addEventListener('change', function (event) {
      var selectedOption = event.target.value;
      if (selectedOption === 'text') {
        revealedTextInput.classList.remove('hidden');
        revealedTextInput.querySelector('input').setAttribute('required', 'required');
        revealedImageInput.classList.add('hidden');
        revealedImageInput.querySelector('input').value = '';
        revealedImageInput.querySelector('input').removeAttribute('required');
      } else {
        revealedTextInput.classList.add('hidden');
        revealedTextInput.querySelector('input').removeAttribute('required');
        revealedTextInput.querySelector('input').value = '';
        revealedImageInput.classList.remove('hidden');
        revealedImageInput.querySelector('input').setAttribute('required', 'required');
      }
    });
  });
};
export default initBurningCake;